import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import { useEffect, useState } from "react";
import useObservable from "@core/hooks/use-observable.hook";
import AccountService from "@app/services/http/account.service";

function ViewPdfModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<{ username: string; otp: string }>) {
  if (!portalData?.username) {
    return "Cần tên file";
  }

  if (!portalData?.otp) {
    return "Cần otp";
  }

  const username = portalData.username;
  const otp = portalData.otp;

  const [pdfUrl, setPdfUrl] = useState<string>("");
  const { subscribeOnce } = useObservable();

  useEffect(() => {
    let objectUrl = "";

    // Giả sử bạn gọi API lấy hợp đồng (hoặc đổi thành AccountService.getContract(username))
    subscribeOnce(AccountService.getContract(username, otp), (res: any) => {
      // 1. Kiểm tra xem res có phải là Axios Response (chứa res.data) hay không
      let rawData = res?.data ? res.data : res;

      // 2. Đảm bảo dữ liệu thu được là kiểu Blob với MIME-type application/pdf
      let blobData: Blob;

      if (rawData instanceof Blob) {
        // Nếu response đã là Blob, tạo Blob mới ép MIME-type chuẩn để browser hiểu đúng là PDF
        blobData = new Blob([rawData], { type: "application/pdf" });
      } else {
        // Trường hợp HttpService lỡ parse ra chuỗi/object, tự đóng gói lại thành Blob PDF
        blobData = new Blob([rawData], { type: "application/pdf" });
      }

      // 3. Tạo Object URL cho Blob PDF
      objectUrl = URL.createObjectURL(blobData);
      setPdfUrl(objectUrl);
    });

    // Cleanup URL khi unmount hoặc đổi username để tránh leak bộ nhớ
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [username]);

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="p-2 pr-10 pt-10 w-[90vw] max-w-5xl h-[90vh] flex flex-col items-center justify-center">
        {pdfUrl ? (
          <iframe
            className="w-full h-full border-0 rounded-lg shadow-sm"
            src={pdfUrl}
            title="PDF Preview"
          />
        ) : (
          <div className="flex items-center gap-2 text-gray-500">
            <span className="animate-spin">⏳</span>
            <span>Đang tải hợp đồng...</span>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default ViewPdfModal;
